/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-11-07 20:31:45
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-12-23 15:58:44
 * @FilePath: \mpc-monorepo\features\mpc-common\src\features\MPCDemand\KOLInquiryForQuotation\cells\HistoricalCooperationCell\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { Tag } from '@bedrock/components';
import { EllipsisTooltip, CellDescriptions } from '@mpc/components';
import { CurrencyEnum } from '#services/api';
import { priceFormat } from '#utils';
import MPCProCurrency from '#components/MPCProCurrency';
import { KOLDemandCategory } from '../../KOLTable/type';

interface HistoricalCooperationCellProps {
  /** 是否为空 */
  isEmpty?: boolean;
  /** 是否有历史合作 */
  hasHistory?: boolean;
  /** 平均单次/单小时价格 */
  avgPrice?: number;
  /** 价格币种 */
  priceCurrency?: CurrencyEnum;
  /** 平均15日CPM */
  avgCPM?: number;
  /** 平均直播CPM(PV) */
  avgCPMPV?: number;
  /** 平均直播CPM(UV) */
  avgCPMUV?: number;
  /** 视图币种 */
  viewCurrency?: CurrencyEnum;
  /** 类型：直播单、图文单 */
  category?: KOLDemandCategory;
}

/**
 * 历史合作信息展示组件
 */
const HistoricalCooperationCell: React.FC<HistoricalCooperationCellProps> = ({
  isEmpty,
  hasHistory,
  avgPrice,
  priceCurrency = 'RMB',
  avgCPM,
  avgCPMPV,
  avgCPMUV,
  viewCurrency,
  category,
}) => {
  if (isEmpty) {
    return <div>--</div>;
  }

  return (
    <CellDescriptions
      column={1}
      maxDisplayCount={4}
      items={[
        {
          label: '是否有历史合作',
          show: true,
          children: (
            <Tag
              color={hasHistory ? 'light-green' : 'light-grey'}
              text={hasHistory ? '是' : '否'}
              size="xSmall"
            />
          ),
        },
        {
          label: '平均单次/单小时价格',
          show: true,
          children: (
            <MPCProCurrency
              viewCurrency={viewCurrency}
              fieldProps={{
                value: { currency: priceCurrency, amount: avgPrice },
                currencyBeforeAmount: false,
                highlight: false,
              }}
            />
          ),
        },
        {
          label: '平均15日CPM',
          show: category === 'text_and_image',
          children: (
            <EllipsisTooltip
              clamp={1}
              text={avgCPM?.toLocaleString() || '--'}
            />
          ),
        },
        {
          label: '平均直播CPM(PV)',
          show: category === 'live',
          children: (
            <EllipsisTooltip
              clamp={1}
              text={avgCPMPV?.toLocaleString() || '--'}
            />
          ),
        },
        {
          label: '平均直播CPM(UV)',
          show: category === 'live',
          children: (
            <EllipsisTooltip
              clamp={1}
              text={avgCPMUV?.toLocaleString() || '--'}
            />
          ),
        },
      ].filter(item => item.show)}
    />
  );
};

export default HistoricalCooperationCell;
